<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
// import utils from '@/utils/utils'
export default {
  data() {
    return {

    }
  },
  created() {
    // 监听扫码枪事件
    // utils.sweepCode((code) => {
    //   console.log(code);
    // })
  },
  methods: {

  }
}
</script>
<style lang='less'>
@import url("./assets/less/mian.less");
#app {
  height: 100%;
}
</style>
